import { parse } from "date-fns";

export const normalizeDate = (dateString: string) => {
  return parse(dateString, 'yyyy-MM-dd HH:mm:ss XX', new Date());
}
